import { post, get } from './request';
import type { LoginUser } from '../stores/auth.store';

/**
 * 认证 API
 *
 * 对接后端 /api/auth/* 接口
 */

/** 登录请求参数 */
export interface LoginParams {
  username: string;
  password: string;
}

/** 登录响应 */
export interface LoginResult {
  accessToken: string;
  user: {
    id: string;
    username: string;
    name: string;
    role: string;
  };
}

/**
 * 管理员登录
 * POST /api/auth/login
 */
export async function login(params: LoginParams): Promise<LoginResult> {
  return post<LoginResult>('/auth/login', params);
}

/**
 * 获取当前用户信息
 * GET /api/admin/users/profile
 */
export async function getProfile(): Promise<LoginUser> {
  return get<LoginUser>('/admin/users/profile');
}

/**
 * 刷新 Token
 * POST /api/auth/refresh
 */
export async function refreshToken(): Promise<{ accessToken: string }> {
  return post<{ accessToken: string }>('/auth/refresh');
}
